module.exports = __webpack_public_path__ + "img/kefu_save.cc626529.png";